var React = require('react');

function PlayTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 16L10 6V26L27 16Z","fillRule":"nonzero"}));
}

PlayTriangle.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = PlayTriangle;

PlayTriangle.default = PlayTriangle;
